import { createFileRoute } from '@tanstack/react-router'

import CustomerPage from '@/views/customer/pages/customer.page'

export const Route = createFileRoute('/_layout/customer/')({
  component: CustomerPage,
})
